module.exports = __webpack_public_path__ + "img/sort-desc-grey.e0046bbf.svg";